import { useMemo, useState } from 'react';
import { Vector2, Vector2Tuple, Vector3Tuple } from 'three';

import { ThreeEvent } from '@react-three/fiber';
import { useEventCallback } from '@spazious/react-hooks';

import { CanvasLabel } from '../CanvasLabel/index.js';

const htmlToText = (html: string) => {
  const dummyDiv = document.createElement('div');
  const editedText = html.replace(/<div>/g, '\n');
  dummyDiv.innerHTML = editedText;
  return dummyDiv.textContent || '';
};

export const AnnotationCanvasLabel = ({
  content,
  onDrag,
  draggable = true,
  onClick = () => {},
}: {
  width?: number;
  height?: number;
  content: string;
  onDrag?: (payload: { position: Vector2; last: boolean; first: boolean }) => void;
  draggable?: boolean;
  onClick?: (event: ThreeEvent<MouseEvent>) => void;
}) => {
  const text = useMemo(() => htmlToText(content), [content]);
  const [position, setPosition] = useState<Vector3Tuple>([0, 0, 0]);

  const onSizeUpdate = useEventCallback((size: Vector2Tuple) => {
    setPosition([0, size[1] / 2 + 0.5, 0]);
  });

  return (
    <CanvasLabel
      bgColor="rgb(225 225 225 / 70%)"
      bgOpacity={0.6}
      color="black"
      cornerRadius={0.2}
      draggable={draggable}
      fontWeight={600}
      padding={[0.2, 0.2]}
      position={position}
      onClick={onClick}
      onDrag={onDrag}
      onSizeUpdate={onSizeUpdate}
    >
      {text}
    </CanvasLabel>
  );
};
